import "./SidebarAlertsComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {TradingAlert} from "../../../../../trading-alerts/models/alert/TradingAlert";
import {Observable, ReplaySubject} from "rxjs";
import {TradingAlertViewStore} from "../../../../../trading-alerts/view-store/TradingAlertViewStore";
import {TradingAlertService} from "../../../../../trading-alerts/services/TradingAlertService";
import {TradingAlertDialogService} from "../../../../../trading-alerts/services/TradingAlertDialogService";
import {Comparator, Transform} from "../../../../../types/GenericTypes";
import {ArrayUtil} from "../../../../../js/util/ArrayUtil";
import {SystemEventService} from "../../../../../services/system-state/SystemEventService";
import {CurrentUserService} from "../../../../../services/user/CurrentUserService";

export const SidebarAlertsComponent = "tfSidebarAlerts";

export function sidebarAlertsComponent(): IComponentOptions {
    return {
        templateUrl: "app/components/ui/iv-sidebar/views/alerts/SidebarAlertsComponent.html",
        controllerAs: "ctrl",
        controller: SidebarAlertsComponentController
    };
}

export class SidebarAlertsComponentController implements IOnInit, IOnDestroy {

    public alerts$: Observable<Array<TradingAlert>>;
    public viewStore: TradingAlertViewStore;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly tradingAlertService: TradingAlertService,
                       private readonly tradingAlertDialogService: TradingAlertDialogService,
                       private readonly systemEventService: SystemEventService,
                       private readonly currentUserService: CurrentUserService) {
    }

    public $onInit(): void {
        this.viewStore = new TradingAlertViewStore(this.tradingAlertService,
                                                   this.tradingAlertDialogService,
                                                   this.systemEventService,
                                                   this.currentUserService);
        this.alerts$ = this.viewStore
                           .alerts
                           .takeUntil(this.destroyed$)
                           .map(this.sortAlerts());
    }

    private sortAlerts(): Transform<Array<TradingAlert>, Array<TradingAlert>> {
        return (alerts) => ArrayUtil.clone(alerts)
                                    .sort(this.orderByStatusAndCode());
    }

    private orderByStatusAndCode(): Comparator<TradingAlert> {
        return (a, b) => {
            if (a.matched != null && b.matched != null) {
                const matchCompare = a.matched.localeCompare(b.matched);
                if (matchCompare !== 0) {
                    return matchCompare;
                } else {
                    return a.code.localeCompare(b.code);
                }
            } else if (a.matched != null && b.matched == null) {
                return -1;
            } else if (a.matched == null && b.matched != null) {
                return 1;
            } else {
                return a.code.localeCompare(b.code);
            }
        };
    }

    public async addAlert() {
        this.viewStore.addAlert();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
        this.viewStore.destroy();
    }
}
